import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../../auth/authRoles'
import ProfileCard from './profileCard/ProfileCard'
import Profile from '../PersonalInfo/Profile'
import Password from '../PersonalInfo/Password'
import AddDoctor from './doctormanagement/AddDoctor'
import DoctorList from './doctormanagement/DoctorList'
import EditDoctor from './doctormanagement/EditDoctor'
import AddUser from './rolemanagement/AddUser'
import EditUser from './rolemanagement/EditUser'
import RoleList from './rolemanagement/RoleList'
import LocationList from './locationmanagement/LocationList'
import AddLocation from './locationmanagement/AddLocation'
import EditLocation from './locationmanagement/EditLocation'
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy'
import TermsAndConditions from './TermsAndConditions/TermsAndConditions'
const Analytics = Loadable(lazy(() => import('./Analytics')))
const CompletedAnalytics = Loadable(lazy(() => import('./CompletedAnalytics')))

const dashboardRoutes = [
    {
        path: '/dashboard/approvedAppointments',
        element: <Analytics />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/completedAppointments',
        element: <CompletedAnalytics />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/doctorlist',
        element: <DoctorList />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/privacy-policy',
        element: <PrivacyPolicy />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/terms-and-conditions',
        element: <TermsAndConditions />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/rolemanagement',
        element: <RoleList />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/location',
        element: <LocationList />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/location/addLocation',
        element: <AddLocation />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/location/editLocation',
        element: <EditLocation />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/doctorlist/addDoctor',
        element: <AddDoctor />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/doctorlist/editDoctor',
        element: <EditDoctor />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/rolemanagement/addUser',
        element: <AddUser />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/rolemanagement/editUser',
        element: <EditUser />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/profile',
        element: <ProfileCard />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/user-profile',
        element: <Profile />,
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/user-password',
        element: <Password />,
        auth: authRoles.admin,
    },
]

export default dashboardRoutes
